<template>
  <div>    
    <div class="columns">
      <div class="column is-3">
        <p class="subtitle">Categories</p>        
        <div class="card categories-container">
          <p v-if="isCategoriesLoading">Loading categories...</p>
          <tree
            v-if="!isCategoriesLoading"
            :data="categories"
            :options="treeOptions"
            @node:selected="onCategorySelected"
          />
        </div>
      </div>
      <div class="column is-4" v-if="!products">
        <p class="subtitle">Products</p>
        <p v-if="isProductsLoading">Loading products...</p>
        <p v-if="!isProductsLoading && !products">Please select a category to view its products.</p>
      </div>
      <div class="column products-container" v-if="products">
        <div class="columns">
          <div class="column is-2">
            <p class="subtitle" v-if="products">Products({{products.length}})</p>
          </div>
          <div class="column is-7">
            <b-field expanded>
              <b-input v-model="searchName" :disabled="!products || !products.length" placeholder="Search products in this category"></b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <a class="button is-primary full-width-button" @click="openModal" :disabled="!currentSelectedCategory">
              <span class="icon is-small">
                <i class="fas fa-plus"></i>
              </span>
              <span>Add</span>
            </a>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-3" v-if="!isProductsLoading && products" v-for="product in filterBy(products, searchName)" :key="product.docId">
            <div v-if="products.length">
              <div class="card">
                <div class="has-text-centered">
                  <img class="product-image" :src="product.imageUrl || '/static/placeholder_image.png'" alt="Placeholder image">
                </div>
                <div class="card-content">
                  <div class="media">
                    <div class="media-content">
                      <p class="title is-4" :title="product.name">{{product.name | truncate(10)}}</p>
                    </div>
                  </div>
                </div>
                  <footer class="card-footer">
                    <a class="card-footer-item" @click="openModal(product)" title="Edit product">
                      <b-icon type='is-primary' size="is-small" icon="edit"></b-icon>
                    </a>
                    <a class="card-footer-item" @click="deleteProduct(product)" title="Delete product">
                      <b-icon type='is-info' size="is-small" icon="trash"></b-icon>
                    </a>
                    <b-upload class="card-footer-item" v-model="files" @input="uploadImage(product)">
                      <a title="Upload image">
                        <b-icon type='is-info' size="is-small" icon="upload"></b-icon>
                      </a>
                    </b-upload>
                  </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddProduct from './AddProduct';
import ProductsService from './service';
import UploadService from '../../lib/UploadService';

export default {
  name: 'products',

  created() {
    this.fetchCategories();

    this.$bus.$on('PRODUCT_UPDATE', (updatedProduct, isNewProduct) => {
      if (isNewProduct) {
        this.products.unshift(updatedProduct);
      } else {
        this.products = this.products.map(product => {
          if (product.docId === updatedProduct.docId) {
            return updatedProduct;
          }

          return product;
        });
      }
    });
  },

  components: {
    AddProduct
  },

  data() {
    return {
      isCategoriesLoading: true,
      isProductsLoading: false,
      searchName: null,
      isAddUpdateProductModalOpen: false,
      categories: null,
      files: null,
      isLoading: true,
      currentSelectedCategory: null,
      products: [],
      treeOptions: {
        propertyNames: {
          text: 'name',
          children: 'subcategories'
        }
      }
    };
  },

  methods: {
    fetchCategories() {
      ProductsService.categories().then(categories => {
        this.categories = categories;
        this.isCategoriesLoading = false;
      });
    },

    onCategorySelected(category) {
      this.currentSelectedCategory = category;
      this.fetchProducts(category.id);
    },

    fetchProducts(category) {
      this.isProductsLoading = true;
      this.products = null;

      ProductsService.all(category).then(products => {
        this.products = products;
        this.isProductsLoading = false;
      });
    },

    deleteProduct(productToDelete) {
      this.isProductsLoading = true;

      ProductsService.deleteProduct(productToDelete.docId).then(() => {
        this.products = this.products.filter(
          product => productToDelete.docId !== product.docId
        );
        this.isProductsLoading = false;
        this.$toast.open('Product deleted successfully');
      });
    },

    openModal(product = null) {
      this.$modal.open({
        parent: this,
        props: {
          propProduct: product,
          category: this.currentSelectedCategory
        },
        component: AddProduct,
        hasModalCard: true
      });
    },

    uploadImage(product) {
      UploadService(this.files[0], 'products', product.docId)
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    }
  }
};
</script>

<style scoped>
.categories-container {
  padding: 0.5rem;
}
.products-container {
  height: 80vh !important;
  overflow-y: scroll;
}
.product-image {
  height: 100px;
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/Products.vue